
export default {
        
       //Employee Schedule
       employeeSchedule: [],

       //Employee Time Logs
       employeeFiledTimeSheet: [],

       //All added segment per employee
       allSegment:[],

       allShiftType: [],

       allSegmentType:[],

       //Populate Calendar
       calendarEvents:[],

       //
       clockIn: '--/--/---- 00:00:00 AM',
       clockOut: '--/--/---- 00:00:00 AM',
       breakIn: '--/--/---- 00:00:00 AM',
       breakOut: '--/--/---- 00:00:00 AM',
       isDisabled: false,
       isBreak: false,

       latestSegments:[]

       
}